module.exports = __webpack_public_path__ + "static/media/pdf.9ffb8846.svg";